<template>
	<el-dialog title="修改预约" width="800px" class="mh-dialog" :visible.sync="dialogVisible" :show-close="true"
		:close-on-click-modal="false" :close-on-press-escape="false">
		<div class="update-appoint" v-loading="loading">
			<div class="head">
				修改须知：
				<template v-for="(item, index) in notices">
					<div :key="'notice_'+index">
						{{ item.itemDesc }}
					</div>
				</template>
			</div>
			<!--        可预约时间-->
			<!--<div class="appointment">
				<div class="userCon">
					<div class="appointmentTime">可预约时间</div>
					<div class="appTime">
						<div class="changeTime" style="justify-content: center;">
							<el-button v-if="showLast" @click="selectWeek('last')"><img src="../../../assets/img/leftTime.png" alt=""
								width="12">
							</el-button>
							<el-button v-else>&nbsp;</el-button>
							<span class="time">{{ time }}</span>
							<el-button @click="selectWeek('next')"><img src="../../../assets/img/rightTime.png" alt=""
								width="12"></el-button>
&lt;!&ndash;							<span class="time">{{time}}</span>&ndash;&gt;
						</div>

						<div class="timeWeek">
							<div v-for="(day,index) in appointArr" class="week" :key="'week_'+index">
								<div class="weekDay" style="display: flex;flex-direction: column;">
									<span>{{ day.date.substr(-5) }}</span>
									<span>{{ day.dayOfWeek }}</span>
								</div>
								<div v-for="(item,ind) in day[day.date]" :key="'day_'+ind" class="date">
									<div v-if="item.isAvailable">
										<template v-if="new Date().getTime() < item.startDateTime">
											<div class="appoint-slot-div" @click="toggleChoose($event,item)" :data-date="day.date+' '+ind">
												<span>{{ ind.substr(0,5) }}</span>
												<span style="width: 33px">~</span>
												<span>{{ ind.substr(-5) }}</span>
											</div>
										</template>
										<template v-else>
											<div class="appoint-slot-div disabled">
												<span>{{ ind.substr(0,5) }}</span>
												<span style="width: 33px">~</span>
												<span>{{ ind.substr(-5) }}</span>
											</div>
										</template>
									</div>
									<div v-else class="appoint-slot-div disabled">已约满</div>
								</div>
								<template v-if="!day[day.date]">
									<div class="date">
										<div class="appoint-slot-div disabled">不可预约</div>
									</div>
								</template>
							</div>
						</div>
						&lt;!&ndash;
						<div class="timeWeek">
							<div v-for="(day,index) in appointArr" class="week" :key="'week_'+index">
								<div class="weekDay">
									<span>{{day.dayOfWeek}}/{{Number(day.date.substr(-2))}}</span>
								</div>
								<div v-for="(item,ind) in day[day.date]" :key="'day_'+ind" class="date">
								<span @click="toggleChoose($event)" v-if="item.isAvailable"
									:data-date="day.date+'-'+ind">{{ind}}:00<br>-<br/>{{ind}}:59</span>
									<span v-else class="disabled">已约满</span>
								</div>
							</div>
						</div>
						&ndash;&gt;
					</div>
				</div>
			</div>-->
			<appointment ref="appointment" :account="doctorAccount" @selectCBK="selectCBK"
				:selectedNumLimit="selectedNumLimit"></appointment>
			<div>
				<el-input type="textarea" v-model="eventContent"></el-input>
			</div>

		</div>
		<div slot="footer">
			<el-button @click="dialogVisible = false">取消</el-button>
			<el-button @click="submit()">提交</el-button>
		</div>
	</el-dialog>
</template>

<script>
  import base from "@/api/common";
  import {getAxios, postAxios} from "@/api/http";
  // import timezone from "@/api/timezone";

  export default {
    name: "update-appoint",
    components: {
      'appointment': () => import('../../appointment/appointment')
    },
    data() {
      return {
        doctorAccount: '',

        dialogVisible: false,
        notices: [],
        appointId: -999,
        loading: false,
        eventContent: '',
        choosed: {},//选中对象
        selectedNumLimit: 1,// 默认为1，从后台查找预约单能否修改时一起传回来

      }
    },
    methods: {
      selectCBK(choosed) {
        this.choosed = choosed;
      },
      submit() {
        let vm = this;
        const choosed = vm.choosed;
        if (this.isEmptyObject(vm.choosed)) {
          this.$message.error("请先选择时间");
          return;
        }
        let params = {
          appointId: vm.appointId,
          appointDate: choosed.appointDate,
          appointStartTime: choosed.appointStartTime,
          appointEndTime: choosed.appointEndTime,
          slotNum: choosed.slotNum,
          endSlot: choosed.endSlot,
          timeSlot: choosed.appointSlot,

					appointStartLongtime: choosed.appointStartLongtime,
					appointEndLongtime: choosed.appointEndLongtime,

          eventContent: vm.eventContent
        }
        postAxios(base.api.approveProcess.appointUpdate, params)
          .then((res) => {
            if (res.data.status === 'success') {
              vm.dialogVisible = false;
              vm.$parent.$message.success('修改申请提交成功，等待对方确认。');
            } else {
              vm.$parent.$message.error('修改失败');
            }
          }).catch((err) => {
          console.error(err);
          vm.$message.error('操作失败');
        })
      },
      async initData() {
        let vm = this;
        vm.getNotices();
      },
      getNotices() {
        let vm = this;
        getAxios(base.api.dict.appoint.update)
          .then((res) => {
            if (res.data.status == 'success') {
              vm.notices = res.data.list;
            }
          });
      },
      isEmptyObject(obj) {
        for (let objKey in obj) {
          return false;
        }
        return true;
      }
    },
    mounted() {
    },
    computed: {
    
		}
  }
</script>

<style lang="scss" scoped>
	.mh-dialog {
		::v-deep.el-dialog__body {
			max-height: 65vh !important;
			min-height: 100px;
			overflow-y: scroll;
		}
	}

</style>
